
  import { Component, Mixins } from 'vue-property-decorator';
  import FormModal from '@/mixins/formModal';
  import ResourcesFilter from '@/components/filters/Resources.vue';

  @Component({ components: { ResourcesFilter } })
  export default class RestaurantModal extends Mixins(FormModal) { }
